import React, { useState } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';

/**
 * Cellule "Nom client" enrichie avec popover ACTION REQUISE.
 * - Hover : ouvre la popover
 * - Clic  : la "pin" (reste ouverte même après mouseleave)
 * - 2e clic : la ferme
 * Affiche : nom client, ancien email (mail_client), nouveau email, date de réception.
 */
export const ActionRequiseEmailCell = ({ ticket }) => {
  const [pinned, setPinned] = useState(false);
  const [hovered, setHovered] = useState(false);

  const newEmail = ticket.action_requise_new_email;
  const oldEmail = ticket.mail_client;
  const newEmailDate = ticket.action_requise_new_email_date
    ? new Date(ticket.action_requise_new_email_date).toLocaleDateString('fr-FR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
      })
    : '';
  const sameEmail = newEmail && oldEmail && newEmail.toLowerCase().trim() === oldEmail.toLowerCase().trim();
  const open = pinned || hovered;

  return (
    <Popover open={open} onOpenChange={(o) => { if (!o) { setPinned(false); setHovered(false); } }}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setPinned(p => !p); }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="truncate max-w-[100px] block text-xs cursor-pointer underline decoration-dotted decoration-yellow-400 underline-offset-2 text-left"
          data-testid={`new-email-tooltip-${ticket.id}`}
          title=""
        >
          <span className="text-yellow-400 mr-0.5">📧</span>{ticket.nom_client || '-'}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        sideOffset={8}
        className="w-auto min-w-[280px] max-w-sm bg-zinc-900 border-2 border-yellow-400/60 text-white px-4 py-3 shadow-2xl rounded-lg"
        onPointerDownOutside={() => { setPinned(false); setHovered(false); }}
        onEscapeKeyDown={() => { setPinned(false); setHovered(false); }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="space-y-2">
          <div className="text-yellow-400 font-bold uppercase text-[11px] tracking-wider flex items-center gap-1.5 pb-1.5 border-b border-zinc-700">
            <span>📧</span><span>ACTION REQUISE</span>
            {pinned && <span className="ml-auto text-[9px] text-zinc-500 font-normal normal-case tracking-normal">📌 épinglé</span>}
          </div>
          <div className="text-white font-semibold text-sm leading-tight">
            {ticket.nom_client || '-'}
          </div>
          {oldEmail && (
            <div className="text-xs">
              <div className={`uppercase tracking-wide text-[10px] mb-0.5 ${sameEmail ? 'text-emerald-400/80' : 'text-zinc-500'}`}>
                Ancien email{sameEmail ? ' (identique)' : ''}
              </div>
              <div
                className={`break-all font-mono text-[12px] ${sameEmail ? 'text-emerald-300' : 'text-zinc-300 line-through decoration-zinc-600'}`}
                onClick={(e) => { e.stopPropagation(); navigator.clipboard?.writeText(oldEmail); }}
                title="Cliquer pour copier"
              >
                {oldEmail}
              </div>
            </div>
          )}
          {newEmail && !sameEmail && (
            <div className="text-xs">
              <div className="text-yellow-400 uppercase tracking-wide text-[10px] mb-0.5 flex items-center gap-1">
                <span>📨</span><span>Nouveau email acheteur</span>
              </div>
              <div
                className="text-yellow-200 font-mono text-[12px] break-all font-bold cursor-pointer hover:underline"
                onClick={(e) => { e.stopPropagation(); navigator.clipboard?.writeText(newEmail); }}
                title="Cliquer pour copier"
                data-testid={`new-email-value-${ticket.id}`}
              >
                {newEmail}
              </div>
            </div>
          )}
          {newEmailDate && (
            <div className="text-[11px] text-zinc-400 flex items-center gap-1.5 pt-1.5 border-t border-zinc-700/60">
              <span>📅</span><span>Reçu le {newEmailDate}</span>
            </div>
          )}
          <div className="text-[9px] text-zinc-600 italic pt-1">
            Clic pour {pinned ? 'désépingler' : 'épingler'}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ActionRequiseEmailCell;
